import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { languagesManagement } from "../../../../../../hooks/api/LanguagesManagement/LanguagesManagement";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";


const EditLanguages = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const { languageId } = useParams();
    const [formErrors, setFormErrors] = useState([]);
    const { useUpdateLanguageMutation, useViewLanguageMutation} = languagesManagement;
    const [updateLanguages, {isLoading: isUpdateingLanguage}] = useUpdateLanguageMutation();
    const [viewLanguage] = useViewLanguageMutation();

    const tabs = [
        { title: t('languages.title'), isActive: true },
        { title: t('program.title'), onClick: () => gotoProgramsTab() },
    ];

    const gotoProgramsTab = () => {
        navigate("/settings/programs/programs");
    }
    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {...values};
        updateLanguages({body, languageId}).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/languages/languages");
                toast.info(result?.data?.info?.responseMessage);
            }
        });
    };

    useEffect(() => {
        viewLanguage(languageId).then((result) => {
            formRef.current.setValues(result?.data);
            console.log(result?.data);
        });

    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/languages/languages" />
                <Button title={t('save')} isDisabled={isUpdateingLanguage} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
            <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("languages.title")} />
                    <Link title={t("languages.title")} />
                    <Link title={t("languages.editLanguage")} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        name: ""
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                        <Row>
                            <Field>
                                <Input
                                    name="name"
                                    label={t("languages.name")}
                                    required={true}
                                    value={values.name}
                                    onChange={handleChange}
                                    error={formErrors?.name}
                                />
                            </Field>
                        </Row>
                    </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default EditLanguages;